import { createRouter, createWebHashHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { useUserStore } from '@/stores/user'
import website from '@/const/website'

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/LoginView.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/',
    component: () => import('@/components/layout/MainLayout.vue'),
    meta: { requiresAuth: true },
    redirect: website.firstPage.path,
    children: [
      {
        path: 'factory/style',
        name: 'FactoryStyle',
        component: () => import('@/views/factory/FactoryStyle.vue'),
        meta: { title: '工厂款式库', requiresAuth: true },
      },
      {
        path: 'factory/style/add',
        name: 'AddStyle',
        component: () => import('@/views/factory/AddStyle.vue'),
        meta: { title: '新增工厂款号', requiresAuth: true, hidden: true, activeTagName: 'FactoryStyle' },
      },
      {
        path: 'user/change-password',
        name: 'ChangePassword',
        component: () => import('@/views/user/ChangePassword.vue'),
        meta: { title: '修改密码', requiresAuth: true, hidden: true },
      },
    ],
  },
]

const router = createRouter({
  // Use hash routing so deployed refreshes do not depend on server-side history fallback.
  history: createWebHashHistory(),
  routes,
})

// 判断路由是否在免权限白名单中
function isAllowRoute(path: string): boolean {
  return website.allowList.some((item) => {
    // 支持通配符匹配，如 '/advanced-router/mutative-detail/*'
    if (item.endsWith('/*')) {
      const prefix = item.slice(0, -1)
      return path.startsWith(prefix)
    }
    return path === item
  })
}

// 全局导航守卫 - 登录拦截 + 动态设置页面标题
router.beforeEach((to, _from, next) => {
  const userStore = useUserStore()

  // 设置浏览器标签页标题
  const pageTitle = (to.meta?.title as string) || ''
  document.title = pageTitle ? `${pageTitle} - ${website.title}` : website.title

  // 判断是否需要登录：allowList 中的路径无需权限
  const needAuth = !isAllowRoute(to.path)

  if (needAuth && !userStore.token) {
    // 需要登录但未登录，跳转登录页
    next({ name: 'Login', query: { redirect: to.fullPath } })
  } else if (to.name === 'Login' && userStore.token) {
    // 已登录用户访问登录页，重定向到首页
    next(website.firstPage)
  } else {
    next()
  }
})

export default router
